<template>
  <SvgIcon
    :iconContent="iconContent"
    :iconAlt="iconAlt"
    :iconStyle="iconStyle"
  />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onBeforeUnmount,
  onMounted,
  computed,
} from "vue";
import { SvgIcon } from "@/components/index.ts";
import wifiSvg from "@/assets/images/svg/wifi.svg";
import noWifiSvg from "@/assets/images/svg/no-wifi.svg";
import { LogService } from "@/services/logging";

export default defineComponent({
  name: "NavbarDetectInternet",
  components: {
    SvgIcon,
  },
  setup() {
    let isOnline = ref(window.navigator.onLine);
    const iconStyle = "filter: contrast(170%) invert(100%);";

    const iconContent = computed(() => (isOnline.value ? wifiSvg : noWifiSvg));
    const iconAlt = computed(() => (isOnline.value ? "wifi" : "no wifi"));

    const updateOnlineStatus = (e: Event) => {
      const { type } = e;

      isOnline.value = type === "online";
      if (!isOnline.value) {
        // log will be synced once internet connection is restored
        LogService.info(
          "No internet connection found. App is running in offline mode."
        );
      }
    };

    onMounted(() => {
      window.addEventListener("online", updateOnlineStatus);
      window.addEventListener("offline", updateOnlineStatus);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    });

    return {
      isOnline,
      iconContent,
      iconAlt,
      iconStyle,
    };
  },
});
</script>
